
export const TOKEN_PARAM_NAME = 'tttok'
export const RESEND_EMAIL_TOKEN_PARAM_NAME = 'ttrtok'
export const ERROR_PARAM = 'tterr'
export const TURNTOSKU_PARAM = 'turntosku'
export const TURNTO_EMAIL_TYPE = 'turntoEmailType'

export type TurnToFlow = 'review' | 'rebelmail' // RSE, handled in review flows
  | 'revpr' // purchase required confirmation, handled in review flows
  // handled in confirmation-message-flows
  | 'revcr' // confirmation required review confirmation
  | 'revco' // confirmation optional review confirmation
  | 'qco' // confirmation optional question confirmation
  | 'qcr' // confirmation required question confirmation
  | 'aco' // confirmation optional answer confirmation
  | 'acr' // confirmation required answer confirmation
  | 'repco' // confirmation optional reply confirmation
  | 'repcr' // confirmation required reply confirmation
  // handled in QA flows
  | 'answer' // clicking "answer this question" in question email
  | 'irrelevantq' // clicking not apporpriate link in question email
  | 'optout' // clicking the opt-out link in RSE or question email
  | 'thankanswer' // clicking "reply" from an answer email
  | 'thanka' // clicking "thank" from an answer email
  | 'answerview' // clicking on "see all answers" from answer email
  | 'answerreply' // clicking "reply" from reply email
  | 'replyview' // clicking on "see all answers" from reply email
  | 'sellerrating' // seller rating
